"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorInputState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var bearing_input_state_1 = require("./bearing.input.state");
var distance_input_state_1 = require("./distance.input.state");
var input_select_1 = require("./input.select");
var input_state_1 = require("./input.state");
var PLACEMENT_TO_SPANS_COUNT_MAP = {
    Inline: 1,
    Bisect: 2,
    Other: 0
};
var AnchorInputState = /** @class */ (function (_super) {
    tslib_1.__extends(AnchorInputState, _super);
    function AnchorInputState(field) {
        var _this = _super.call(this, field.schema.displayName) || this;
        _this.field = field;
        _this.cachedSpanFields = [];
        _this._error = '';
        _this.isLabelShown = false;
        _this.distance = new distance_input_state_1.DistanceInputState('Distance');
        _this.bearing = new bearing_input_state_1.BearingInputState('Bearing');
        _this.placement = new input_select_1.SelectInputState('Placement');
        _this.placement.setOptions([
            {
                key: (0, i18n_1.Translate)(i18n_1.T.ANCHOR_ALIGNMENT_INLINE),
                value: 'Inline'
            },
            {
                key: (0, i18n_1.Translate)(i18n_1.T.ANCHOR_ALIGNMENT_BISECT),
                value: 'Bisect'
            },
            {
                key: (0, i18n_1.Translate)(i18n_1.T.ANCHOR_ALIGNMENT_OTHER),
                value: 'Other'
            }
        ]);
        _this.relatedSpans = [
            new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_TITLE, 'A')),
            new input_select_1.SelectInputState((0, i18n_1.Translate)(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_TITLE, 'B'))
        ];
        _this.reaction(function () { return _this.bearing.value; }, function () {
            if (_this.bearing.focused) {
                _this.placement.setValue('Other');
                _this.relatedSpans.forEach(function (x) { return x.setValue(undefined); });
            }
        });
        return _this;
    }
    Object.defineProperty(AnchorInputState.prototype, "value", {
        get: function () {
            if (this.distance.value == null && this.bearing.value == null) {
                return null;
            }
            return {
                bearing: this.bearing.value,
                distance: this.distance.value,
                pitch: this.pitch,
                collectionTool: 'VECTOR',
                placement: this.placement.value,
                // we only want to return the correct number of spans based off the placement, ie. inline should only return 1 span
                relatedSpanIds: this.relatedSpans.map(function (x) { return x.value; }).slice(0, PLACEMENT_TO_SPANS_COUNT_MAP[this.placement.value])
            };
        },
        enumerable: false,
        configurable: true
    });
    AnchorInputState.equal = function (value1, value2) {
        if (value1 === value2) {
            return true;
        }
        if (value1 == null || value2 == null) {
            return false;
        }
        return distance_input_state_1.DistanceInputState.equal(value1.distance, value2.distance) &&
            bearing_input_state_1.BearingInputState.equal(value1.bearing, value2.bearing) &&
            value1.pitch === value2.pitch &&
            value1.placement === value2.placement;
    };
    AnchorInputState.prototype.populateRelatedSpansOptions = function (fields) {
        var options = [];
        this.cachedSpanFields = fields;
        fields.forEach(function (x) {
            var spanLabel = x.parent && x.parent instanceof core_shared_1.CollectionModelFieldSubFormInstance
                ? x.parent.title
                : x.schema.displayName;
            options.push({
                key: spanLabel,
                value: x.id
            });
        });
        this.relatedSpans.forEach(function (x) { return x.setOptions(options); });
    };
    AnchorInputState.prototype.setValue = function (val) {
        if (val == null) {
            this.distance.setValue(null);
            this.bearing.setValue(null);
            this.pitch = null;
            this.placement.setValue(null);
            this.setError(null);
            return;
        }
        this.distance.setValue(val.distance);
        this.pitch = val.pitch;
        this.placement.setValue(val.placement);
        var bearing = this.bearing.focused
            ? val.bearing
            : this.calculateBearingFromPlacement() || val.bearing;
        if (bearing !== this.cachedBearing) {
            this.bearing.setValue(bearing);
            this.cachedBearing = bearing;
        }
        this.relatedSpans[0].setValue((0, lodash_1.get)(val, ['relatedSpanIds', '0']));
        this.relatedSpans[1].setValue((0, lodash_1.get)(val, ['relatedSpanIds', '1']));
        switch (val.placement) {
            case 'Bisect':
                this.relatedSpans.forEach(function (x) { return x.setDisabled(false); });
                break;
            case 'Inline':
                this.relatedSpans[0].setDisabled(false);
                this.relatedSpans[1].setDisabled(true);
                break;
            default:
                this.relatedSpans.forEach(function (x) { return x.setDisabled(true); });
        }
        if (val.distance == null && val.bearing == null) {
            this.setError(null);
        }
        else if (val.distance == null) {
            this.setError(i18n_1.T.DISTANCE_MISSING);
        }
        else if (val.bearing == null) {
            this.setError(i18n_1.T.BEARING_MISSING);
        }
        else {
            this.setError(null);
        }
    };
    AnchorInputState.prototype.calculateBearingFromPlacement = function () {
        var _this = this;
        var placement = this.placement.value;
        var nextBearing;
        var values = this.relatedSpans.map(function (x) { return x.value; });
        var temp = [];
        this.field.collection.forEachField(function (x) { return temp.push(x.id); });
        if (placement === 'Bisect') {
            if (!values.filter(Boolean).length) {
                this.setError(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT);
            }
            var spanRadians = values
                .map(function (fieldId) { return _this.field.collection.getFieldDeep(fieldId); })
                .map(function (x, index) {
                var value = (0, lodash_1.get)(x, ['value', 'bearing']);
                if (!value) {
                    _this.setError(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE);
                }
                return value;
            })
                .sort();
            // ensure all values are defined and are numbers
            if (spanRadians.some(function (x) { return typeof x !== 'number'; })) {
                return undefined;
            }
            var _a = spanRadians.map(function (x) { return core_shared_1.IkeAngle.toDegrees(x); }), a = _a[0], b = _a[1];
            // find the angle between the two bearings
            var theta = a - b;
            // find the bisect angle of theta relative to a.
            // basically we derive what half theta is (θ/2) and minus that value
            // from a to derive what the bisector is
            var bisect = a - (theta / 2);
            // We then want to ensure the anchor is placed on convex side of the angle
            // so we add 180 deg if θ < 180
            var result = Math.abs(theta) < 180 ? bisect + 180 : bisect;
            nextBearing = core_shared_1.IkeAngle.toRadians(result);
        }
        if (placement === 'Inline') {
            if (this.relatedSpans[0].value === undefined) {
                this.setError(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE);
            }
            var relatedSpan = this.field.collection.getFieldDeep(this.relatedSpans[0].value);
            var bearing = (0, lodash_1.get)(relatedSpan, ['value', 'bearing']);
            if (!bearing) {
                this.setError(i18n_1.T.ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE);
            }
            nextBearing = core_shared_1.IkeAngle.toRadians(180) + bearing;
        }
        return nextBearing;
    };
    AnchorInputState.prototype.hasError = function () {
        return _super.prototype.hasError.call(this) || this.distance.hasError() || this.bearing.hasError() || this.placement.hasError() || this.relatedSpans.some(function (x) { return x.hasError(); });
    };
    Object.defineProperty(AnchorInputState.prototype, "error", {
        get: function () {
            // Don't show an error message if one is already being shown
            if (this.distance.hasError() || this.bearing.hasError() || this.placement.hasError()) {
                return null;
            }
            if (!this.distance.value) { // distance is empty
                if (this.placement.value || this.bearing.value > 0) { // placement has a value or the bearing has an actual value
                    return i18n_1.T.DISTANCE_MISSING;
                }
                return this._error; // everything is empty
            }
            else if (this.distance.value && this.bearing.value === null) { // does bearing have an actual value
                return i18n_1.T.BEARING_MISSING;
            }
            else if (this.placement.value === null && this.distance.value) { // does placement have a valid value
                return i18n_1.T.PLACEMENT_MISSING;
            }
            // everything has a valid value
            return this._error;
        },
        set: function (msg) {
            this._error = msg || '';
        },
        enumerable: false,
        configurable: true
    });
    AnchorInputState.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.distance.destroy();
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], AnchorInputState.prototype, "value", null);
    tslib_1.__decorate([
        mobx_1.action
    ], AnchorInputState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], AnchorInputState.prototype, "error", null);
    return AnchorInputState;
}(input_state_1.InputState));
exports.AnchorInputState = AnchorInputState;
//# sourceMappingURL=anchor.input.state.js.map